module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lP78ox/tc-custom/9781614238836.jpg?1738389448480",
      "alt": "This image is the cover for the book See Alabama First"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("See Alabama First\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tourism in the Southeast is often associated with Florida--a state that essentially defined the industry in America. Yet Alabama has a fascinating history of tourism all its own. It all began with an enterprising politician. In 1916, John Hollis Bankhead went to great lengths to ensure that one of America's first transcontinental highways went directly through Alabama. Though it was a less efficient route for highway travelers, it marked the birth of Alabama's fledgling tourism industry, which grew exponentially with each passing decade. Since he was a boy, author Tim Hollis has traveled from the Shoals to the coast and amassed an unrivaled knowledge of Alabama tourism. From restored and preserved historic destinations to campy tourist traps and outrageous roadside attractions, this is the complete story of tourism in Alabama.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Hollis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tim Hollis is a pop culture historian who has authored over twenty-one books ranging in subjects from southern tourism nostalgia to Birmingham history to Children's entertainment, among other topics. He also owns a museum of toys, advertising, holiday memorabilia and other baby boomer relics.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0